<p-dialog
  #fastFormaPagto
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar forma de pagamento</span>
      <i class="mdi mdi-credit-card-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row">
    <div class="flex-column col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Nome</mat-label>
        <input
          matInput
          type="text"
          [formControl]="form.get('nome')"
          (blur)="actionFnCheckEntityExist(form.get('nome'))"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('duplicate')
        "
      >
        Já existe uma forma de pagamento cadastrada com esse nome!
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('required')
        "
      >
        O nome é obrigatório
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('repeated')
        "
      >
        Já existe uma forma de pagamento com esse nome
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('maxlength')
        "
      >
        O nome deve conter no máximo 30 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('isEmptyValue')
        "
      >
        Valor inválido: remova os espaços em branco!
      </small>
    </div>

    <div class="col-md-5 mt-3" *ngIf="usaFiscal">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Indicador de forma de pagamento</mat-label>
        <mat-select [formControl]="form.controls.indicador_operacao">
          <mat-option *ngFor="let i of indPagOptions" [value]="i.value">
            {{ i.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('indicador_operacao').touched &&
          form.get('indicador_operacao').hasError('required')
        "
      >
        Definir um tipo para a forma é obrigatório
      </small>
    </div>

    <div class="col-md-7 mt-3" *ngIf="usaFiscal">
      <fast-autocomplete
        [autoFirst]="false"
        [initDataWithEmpty]="true"
        placeholder="Forma pagto SEFAZ"
        [entityService]="formaPagtoSefazService"
        [displayWithEntityFn]="pagtoDisplay"
        displayField="descricao"
        [control]="form.get('forma_pagamento_sefaz')"
        (clearSelection)="form.get('forma_pagamento_sefaz').reset()"
        [messages]="{
          required: 'Obrigatório vincular uma',
          typeIs: 'Valor inválido',
          isEmptyValue: 'Inválido: remova os espaços em branco!'
        }"
        [domain_id]="domainId"
      ></fast-autocomplete>
    </div>

    <div
      class="col-md-12 mt-3"
      *ngIf="
        usaFiscal &&
        form.value.forma_pagamento_sefaz &&
        form.value.forma_pagamento_sefaz.codigo === '99'
      "
    >
      <span class="p-float-label">
        <input
          id="inputtext-uf_destinatario"
          class="input-filters"
          pInputText
          [formControl]="form.get('outra_forma')"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-uf_emitente">
          Outra forma de pagamento *
        </label>
        <small
          class="p-error"
          *ngIf="
            form.get('outra_forma').touched &&
            form.get('outra_forma').hasError('isEmptyValue')
          "
        >
          Inválido: remova os espaços em branco!
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('outra_forma').touched &&
            form.get('outra_forma').hasError('minlength')
          "
        >
          Deve conter o mínimo de 3 caracteres
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('outra_forma').touched &&
            form.get('outra_forma').hasError('maxlength')
          "
        >
          Deve conter no máximo 60 caracteres
        </small>
      </span>
    </div>

    <div
      class="col-md-12 mt-3"
      *ngIf="
        usaFiscal &&
        form.value.forma_pagamento_sefaz &&
        (form.value.forma_pagamento_sefaz.codigo === '03' ||
          form.value.forma_pagamento_sefaz.codigo === '04' ||
          form.value.forma_pagamento_sefaz.codigo === '10' ||
          form.value.forma_pagamento_sefaz.codigo === '11' ||
          form.value.forma_pagamento_sefaz.codigo === '12')
      "
    >
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Tipo de integração do processo de pagamento</mat-label>
        <mat-select [formControl]="form.controls.tipo_integracao">
          <mat-option [value]="i.value" *ngFor="let i of tpIntegraOptions">
            {{ i.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div
      class="col-md-12 mt-3"
      *ngIf="
        form.value.forma_pagamento_sefaz &&
        form.value.forma_pagamento_sefaz.codigo !== '01' &&
        form.value.forma_pagamento_sefaz.codigo !== '02' &&
        usaFiscal
      "
    >
      <fast-autocomplete
        [autoFirst]="false"
        [initDataWithEmpty]="true"
        placeholder="Instituição financeira"
        [entityService]="instituicaoFinanceira"
        displayField="descricao"
        (clearSelection)="form.get('instituicao_pagamento').reset()"
        [control]="form.get('instituicao_pagamento')"
        [messages]="{
          typeIs: 'Valor inválido',
          required: 'Obrigatório selecionar uma'
        }"
        [domainPath]="'domain_org_id'"
        [actionState]="true"
        [insertType]="'instituicao_financeira'"
        [domain_id]="domainId"
      ></fast-autocomplete>
    </div>

    <mat-slide-toggle
      *ngIf="!usaFiscal"
      color="primary"
      [formControl]="form.get('a_prazo')"
      ngDefaultControl
      class="col-md-12 mt-3"
      id="field-a-prazo"
    >
      À prazo
      <mat-hint class="d-block">Define como uma forma à prazo</mat-hint>
    </mat-slide-toggle>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        mat-dialog-close
        [disabled]="loading"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="!form.valid || loading"
      ></button>
    </div>
  </ng-template>
</p-dialog>
